import { Dispatch } from 'redux';
import { EtaActions } from '../store/EtaSlice';
import { NotificationActions } from '../store/NotificationSlice';
import SetAuthHeader, { ManageResponseErrors } from './actionUtils';
import { AccessToken } from '@okta/okta-auth-js';
import { NotificationStatus } from '../components/Notification/Notification';

export const getStoreInfo = (apiUrl: string, storeId: string, accessToken: AccessToken) => {
    return async (dispatch: Dispatch) => {
        const fetchData = async () => {
            dispatch(NotificationActions.showNotification({
                status: NotificationStatus.Search,
                title: 'Search',
                message: 'Fetching Site Info'
            }));
            const response = await fetch(apiUrl + '/api/Eta/getsiteinfo?siteCode=' + storeId, SetAuthHeader(accessToken));

            var resp = ManageResponseErrors(response);

            const data = await response.json();
            return data;
        };

        const fetchSiteTankData = async () => {
            dispatch(NotificationActions.showNotification({
                status: NotificationStatus.Search,
                title: 'Search',
                message: 'Fetching Site Tanks'
            }));
            const response = await fetch(apiUrl + '/api/Eta/getsitetanks?siteCode=' + storeId, SetAuthHeader(accessToken));

            ManageResponseErrors(response);
            if (response.status === 204) {
                return [];
            }
            const data = await response.json();
            return data;
        };

        const fetchEtaData = async (siteId: number) => {
            dispatch(NotificationActions.showNotification({
                status: NotificationStatus.Search,
                title: 'Search',
                message: 'Fetching Site Order Etas'
            }));
            const response = await fetch(apiUrl + '/api/Eta/getorderetas?siteId=' + siteId, SetAuthHeader(accessToken));

            ManageResponseErrors(response);
            if (response.status === 204) {
                return [];
            }
            const data = await response.json();
            return data;
        };

        try {
            const storeDetails = await fetchData();

            const tanks = await fetchSiteTankData();

            if (storeDetails[0].site_Id !== undefined) {
                const orders = await fetchEtaData(storeDetails[0].site_Id);
                dispatch(EtaActions.setStoreInfo({ data: storeDetails, tanks, orders }));
            }
            else {
                dispatch(EtaActions.setStoreInfo({ data: storeDetails, tanks, orders: [] }));
            }

            dispatch(NotificationActions.showNotification({
                status: NotificationStatus.Success,
                title: 'Success',
                message: 'Completed fetching Site Data'
            }));
        }
        catch (error: any) {
            if (error.statusText !== undefined) {
                dispatch(
                    NotificationActions.showNotification({
                        status: NotificationStatus.Http,
                        title: error.status,
                        message: error.statusText
                    })
                );
            }
            else {
                console.log(error);
                dispatch(
                    NotificationActions.showNotification({
                        status: NotificationStatus.Error,
                        title: 'Error!',
                        message: 'Fetching Site Info failed!'
                    })
                );
            }
        }
    };
};

export default getStoreInfo;